export default "__VITE_ASSET__Bpm5o9x7__"